import React, { useState, useEffect } from 'react';
import './NavbarDashboard.css';
import { Link as Anchor, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSignOutAlt,
    faGauge,
    faStore,
    faList,
    faRectangleList,
    faImage,
    faTag,
    faUser
} from '@fortawesome/free-solid-svg-icons';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
import logo from '../../../images/logo.png';
import baseURL from '../../url';
import { useUser } from '../UserContext/UserContext'; // <--- 1. Importar el contexto (ajusta la ruta según tu carpeta)

export default function Navbar() {
    const location = useLocation();
    const [tienda, setTienda] = useState([]);
    const [expanded, setExpanded] = useState(false);
    
    // 2. Extraer logoutUser del contexto global
    const { logoutUser } = useUser();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1024) {
                setExpanded(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const isActive = (path) =>
        location.pathname === path ? 'activeLink' : '';

    // 3. Modificar handleLogout para usar el logout del contexto
    const handleLogout = async (e) => {
        if (e) e.preventDefault();
        await logoutUser(); // Se encarga de llamar a logout.php con credentials: 'include' y limpiar el estado de usuario
    };

    // TODOS LOS LINKS, SIN CONDICIONES
    const links = [
        { to: '/dashboard', icon: faGauge, label: 'Dashboard' },
        { to: '/dashboard/mi-tienda', icon: faStore, label: 'Mi Tienda' },
        { to: '/dashboard/categorias', icon: faList, label: 'Categorías' },
        { to: '/dashboard/productos', icon: faProductHunt, label: 'Productos' },
        { to: '/dashboard/pedidos', icon: faRectangleList, label: 'Pedidos' },
        { to: '/dashboard/banners', icon: faImage, label: 'Banners' },
        { to: '/dashboard/promociones', icon: faTag, label: 'Promociones' },
        { to: '/dashboard/usuarios', icon: faUser, label: 'Usuarios' },
        { to: '/dashboard/metodos-de-pago', icon: faRectangleList, label: 'Métodos' },
    ];

    return (
        <div className={`navbarDashboard ${expanded ? 'expanded' : 'collapsed'}`}>
            <div className="logo">
                <div className="logo-inner">
                    {tienda?.imagen1 ? (
                        <img src={tienda.imagen1} alt="" />
                    ) : (
                        <img src={logo} alt="" />
                    )}

                    <div className="deColumnNav">
                        <ss>{tienda?.nombre || 'Tienda'}</ss>
                        <ss>{tienda?.email || 'email@tienda.com'}</ss>
                    </div>
                </div>

                <button
                    className="nav_toggle2"
                    onClick={() => setExpanded(!expanded)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            <div className="links">
                {links.map(link => (
                    <Anchor
                        key={link.to}
                        to={link.to}
                        className={isActive(link.to)}
                    >
                        <FontAwesomeIcon icon={link.icon} />
                        <span className="nav-label">{link.label}</span>
                    </Anchor>
                ))}
            </div>

            <div className="logout-wrap">
                <Anchor onClick={handleLogout} style={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faSignOutAlt} />
                    <span className="nav-label">Cerrar sesión</span>
                </Anchor>
            </div>
        </div>
    );
}